
    import Vue from 'vue';
    export default Vue.extend({
        name: 'ServiceFail',
        data() {
            return {
                text: null,
                help: null,
                statusCode: null,
                icon: null,
                retryActions: [] as Array<{ fn: () => void, index: number }>,
                retryActionIndex: 0,
                showModal: false,
            }
        },
        busEvents: {
            'show-service-fail'(statusCode: any, actions: Array<() => void>) {
                this.statusCode = statusCode;
                actions.forEach(fn => {
                    if (typeof fn === 'function') {
                        this.retryActions.push({ fn, index: this.retryActionIndex++ });
                    }
                });
            },
        },
        methods: {
            async retryAllActions() {
                this.showModal = false;
                this.retryActions = [];
                this.retryActionIndex = 0;
                const retryAllActions = [...this.retryActions].sort((a, b) => a.index - b.index);
                for (const action of retryAllActions) {
                    if (typeof action.fn === 'function') {
                        await action.fn();
                    }
                }
            },
        },
        watch: {
            showModal(newVal) {
                this.$emit('show-modal', newVal);
            },
            retryActions(newVal) {
                if (Array.isArray(newVal) && newVal.length > 0 && !this.showModal) {
                    this.showModal = true;
                }
            },
            statusCode(newVal) {
                switch (newVal) {
                    case 500:
                        this.text = 'No podemos procesar tu pedido';
                        this.help = 'Por favor, volvé a intentarlo. Si el problema persiste, comunicáte con nosotros.';
                        this.icon = "/icons/disconnect.svg";
                        break;
                    case 204:
                        this.text = 'Lo sentimos, no encontramos ninguna cotización en este momento.';
                        this.help = 'Por favor, revisá que los datos introducidos sean correctos y volvé a intentarlo. De lo contrario, contactate con nosotros o con un Productor Asesor de Seguros.';
                        this.icon = "/icons/empty-state-icon.svg";
                        break;
                    default:
                        this.text = 'No podemos procesar tu pedido';
                        this.help = 'Por favor, volvé a intentarlo. Si el problema persiste, comunicáte con nosotros.';
                        this.icon = "/icons/disconnect.svg";
                        break;
                }
            }
        }
    });
